module.exports = __webpack_public_path__ + "img/插图.8aa96929.png";